import { FamiliarSituationDetails, MaritalStatus } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import { FamiliarSituationForm } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/FamiliarSituation/components/FamiliarSituationForm';
import {
  FamiliarSituationFormSchema,
  FamiliarSituationFormType,
} from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/FamiliarSituation/schemas/FamiliarSituationFormSchema';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

interface FamiliarSituationEditWrapperProps {
  familiarSituationDetails: FamiliarSituationDetails;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog;
  loading: boolean;
  updateBorrowerContract?: (data) => void;
}

export const FamiliarSituationEditDialog = ({
  familiarSituationDetails,
  opened,
  setOpened,
  updateBorrowerContract,
  loading,
  toggleDialog,
}: FamiliarSituationEditWrapperProps) => {
  const FamiliarSituationDefaultValues = {
    maritalStatus: familiarSituationDetails?.maritalSituation.maritalStatus,
    maritalRegime: familiarSituationDetails?.maritalSituation.maritalRegime,
    childSupportNumber: familiarSituationDetails?.childSupportNumber,
  };

  const familiarSituationPreMapper = (useFormValues: FamiliarSituationFormType) => {
    return {
      maritalSituation: {
        maritalStatus: useFormValues.maritalStatus,
        ...(useFormValues.maritalStatus === MaritalStatus.MARRIED
          ? { maritalRegime: useFormValues.maritalRegime }
          : {}),
      },
      childSupportNumber: useFormValues.childSupportNumber as number,
    };
  };

  const onSubmitForm = async (useFormValues: FamiliarSituationFormType) => {
    const preMappedFamiliarSituationValues = familiarSituationPreMapper(useFormValues);
    if (updateBorrowerContract)
      await updateBorrowerContract({ userDetails: { familiarSituationDetails: preMappedFamiliarSituationValues } });
    toggleDialog();
  };
  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      title={'EDIT_FAMILIAR_SITUATION'}
      isLoading={loading}
      onSubmitForm={onSubmitForm}
      defaultValues={FamiliarSituationDefaultValues}
      formSchema={FamiliarSituationFormSchema}
    >
      <FamiliarSituationForm
        familiarSituationDetails={familiarSituationDetails}
        fullWidth={true}
        fieldVariant={FieldVariant.form}
      />
    </EditDialogWrapper>
  );
};
